import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../utils/formats';
import { enumT } from '../../../../../../../utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import { getStandortNameMitGruopID } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import NachweisPositionsSchema from '../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchema.attributes;
const NP_P = NachweisPositionsSchema.attributes;

const InvestitionskostenUebersichtVNLIS: FC<{}> = () => {
	const { application } = useApplication();
	const columns = useMemo(() => {
		let column = [
			{ field: 'id', headerName: 'ID', width: 80, groupable: false, hide: true },
			{ field: 'standort', headerName: 'Standort', width: 300 },
			{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
			{
				field: 'geplanteSumme',
				headerName: 'Summe Projektausgaben',
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return DisplayEuroMUI(value);
				},
			},
		];

		return column;
	}, []);

	const rows = useMemo(() => {
		let row = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, [])
			.filter(
				(ele: any) =>
					get(ele, NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten
			)
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					kostraeger: enumT(get(ele, NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostentraeger.path, '')),
					standort: getStandortNameMitGruopID(
						get(application, VN_P.Foerderantrag.path, {}),
						get(ele, NP_P.Allgemein_Standort_Group_ID.path, '')
					),
					unternehmen: get(
						ele,
						NP_P.Allgemein_Kostenposition.schema.attributes.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path
					),
					name: get(ele, NP_P.Allgemein_Bezeichnung.path),
					kostenKategorie: get(
						ele,
						NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path
					),
					geplanteSumme: get(ele, NP_P.Allgemein_Ausgaben_Kosten.path, 0),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		return {
			aggregation: {
				model: {
					geplanteSumme: 'sum',
				},
			},
			rowGrouping: {
				model: ['standort'],
			},
			columns: {
				columnVisibilityModel: {
					id: false,
					standort: false,
				},
			},
			sorting: {
				sortModel: [
					{
						field: 'kostenKategorie',
						sort: 'asc', // oder 'desc' für absteigende Sortierung
					},
				],
			},
		};
	}, []);

	return (
		<>
			<ApplicationHeading title='Investitionskosten Übersicht' description={PLATZHALTER_TEXT} />
			<div style={{ height: 400, width: '100%' }}>
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					disableRowSelectionOnClick
					hideFooter
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</div>
		</>
	);
};
export default InvestitionskostenUebersichtVNLIS;
